
import { Product } from '~/node_modules/sitisjs/dist/internal/sections/products/models/Product';

export default {
  name: "TableOtherObject",

  data: function () {
    return {
      products: [],

      isHide: false
    }
  },

  props: {
    product: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  mounted: async function () {
    await this.getProducts();
  },

  methods: {
    getProducts: async function () {
      const gruppaPlanirovki = (this.product?.characteristics?.[0]?.characteristics || []).find((t) => t.slug === "code");
      if (!gruppaPlanirovki) {
        this.isHide = true;
        return
      }

      const gruppaPlanirovkiSlug = (gruppaPlanirovki?.values?.[0]?.slug || "");
      if (!gruppaPlanirovkiSlug) {
        this.isHide = true;
        return
      }

      let products = await this.$api.agent.transport.get(`/categories/catalog/products?expand=characteristics&filter[code][]=${gruppaPlanirovkiSlug}&per-page=999&filter[status][]=dostupno`).then((res) => {
        return res?.data || []
      }).catch(() => {
        return []
      })
      products = products.map((t) => new Product(t));
      products = products.map((t) => {
        const plosad = (t?.characteristics?.[0]?.characteristics || []).find((t) => t.slug === "plosad")?.values?.[0]?.value || "";
        const status = (t?.characteristics?.[0]?.characteristics || []).find((t) => t.slug === "status")?.values?.[0]?.value || "";
        const cenaZaM = (t?.characteristics?.[0]?.characteristics || []).find((t) => t.slug === "cena-za-m")?.values?.[0]?.value || "";
        const etaz = (t?.characteristics?.[0]?.characteristics || []).find((t) => t.slug === "etaz")?.values?.[0]?.value || "";

        return {
          ...t,
          status,
          plosad,
          cenaZaM,
          etaz,
        }
      });

      this.products = products;
    },
    clickRowTable: function (product) {
      this.$router.push(product.url)
    },
  }
}
